<template>
    <div>
        
            <div class="row">
                <div class="col-lg-7 mb-lg-0 mb-1">
                    <v-date-picker v-model="date" placeholder="Tarih" :disabled="calculating || updating"/>
                </div>
                <div class="col-5">
                    <div class="d-flex g-1">
                        <input type="number" v-model="rate" class="form-control" placeholder="Oran"/>
                        <v-executer variant="success" :loading="calculating" :disabled="!(date && rate)" :action="calculate">Hesapla</v-executer>
                    </div>
                </div>
            </div>

        <div v-if="!calculating">
            <div v-for="(a,i) in agreements" class="border rounded-lg mt-1" :key="i">
                <h3 class="mb-0 px-75 py-50 bg-light">{{ a.AgreementName }}</h3>
                <div class="table-responsive mb-0">
                    <table class="table table-sm">
                        <tbody>
                            <tr>
                                <th class="w-50 text-nowrap font-weight-bolder border-right">Kod</th>
                                <td class="text-nowrap">{{a.CariCode }}</td>
                            </tr>
                            <tr>
                                <td class="w-50 text-nowrap font-weight-bolder border-right">Cari</td>
                                <td class="text-nowrap">{{a.CariName }}</td>
                            </tr>
                            <tr>
                                <td class="w-50 text-nowrap font-weight-bolder border-right">Sözleşme Kodu</td>
                                <td class="text-nowrap">{{a.AgreementCode}}</td>
                            </tr>
                            <tr>
                                <td class="w-50 text-nowrap font-weight-bolder border-right">Sözleşme Adı</td>
                                <td class="text-nowrap">{{a.AgreementName }}</td>
                            </tr>
                            <tr>
                                <td class="w-50 text-nowrap font-weight-bolder border-right">Sözleşme Baş. Tarihi</td>
                                <td class="text-nowrap">{{a.StartDate}}</td>
                            </tr>
                            <tr>
                                <td class="w-50 text-nowrap font-weight-bolder border-right">Sözleşme Bit. Tarihi</td>
                                <td class="text-nowrap">{{a.ExpireDate}}</td>
                            </tr>
                            <tr>
                                <td class="w-50 text-nowrap font-weight-bolder border-right">Bir Önceki Yakıt Fiyatı Tarihi</td>
                                <td class="text-nowrap">{{a.LastPriceUpdateDate}}</td>
                            </tr>
                            <tr>
                                <td class="w-50 text-nowrap font-weight-bolder border-right">Bir Önceki Yakıt Fiyatı</td>
                                <td class="text-nowrap">{{a.LastPriceUpdateFuelPrice}}</td>
                            </tr>
                            <tr>
                                <td class="w-50 text-nowrap font-weight-bolder border-right">Değişim Oranı (%)</td>
                                <td class="text-nowrap">{{a.ChangeRateStr}}</td>
                            </tr>
                            <tr>
                                <td class="w-50 text-nowrap font-weight-bolder border-right">Yakıt Fiyatı ({{ date_format }})</td>
                                <td class="text-nowrap">{{a.CurrentFuelPrice}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-responsive mb-0">
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th class="text-nowrap">Başlangıç Bölgesi</th>
                                <th class="text-nowrap">Bitiş Bölgesi</th>
                                <th class="text-nowrap">Araç Tipi</th>
                                <th class="text-nowrap">Ürün Tipi</th>
                                <th class="text-nowrap">Taşıma Tipi</th>
                                <th class="text-nowrap">Eski Fiyat</th>
                                <th class="text-nowrap">Yeni Fiyat</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(r,ii) in (a.Routes || [])" :key="ii">
                                <td class="text-nowrap">{{ r.StartRegionName }}</td>
                                <td class="text-nowrap">{{ r.EndRegionName }}</td>
                                <td class="text-nowrap">{{ r.VehicleTypeName }}</td>
                                <td class="text-nowrap">{{ r.StockName }}</td>
                                <td class="text-nowrap">{{ r.Status }}</td>
                                <td class="text-nowrap">{{ r.OldPriceStr }}</td>
                                <td class="text-nowrap">{{ r.NewPriceStr }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="py-1 border-top px-1 text-right">
                    <button class="btn btn-secondary d-inline-flex align-items-center" :disabled="updating" v-on:click="update(a)">
                        <b-spinner v-if="currentUpdatingId == a.AgreementId" class="mr-1" small ></b-spinner>
                        Güncelle
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { AgreementApi } from '@/api/agreement'
import { BSpinner } from 'bootstrap-vue';
import moment from 'moment';
export default{
    components:{
        BSpinner
    },
    props:{
        ids:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        return {
            calculating:false,
            date:null,
            rate:null,
            agreements:[],
            currentUpdatingId: null,
            updating: null
        }
    },
    mounted(){
        this.$emit('calculated',false)
    },  
    methods:{
        calculate(){
            this.$emit('calculated',false)
            this.calculating= true
            AgreementApi.CalculatePrices({
                AgreementIds:this.ids,
                Date: this.date,
                Rate: this.rate
            }).then(res => {
                if(res.data.Success){
                    this.agreements = res.data.Data
                    this.$emit('calculated',(res.data.Data).some(d => (d.Routes || []).length > 0))
                }else{
                    this.$result(res)
                }
                this.calculating = false
            }).catch(err => {
                this.calculating = false
                this.$result(null,err)
            })
        },
        update(item){
            this.currentUpdatingId = item.AgreementId
            const payload = {
                AgreementId: item.AgreementId,
                FuelPriceItems: item.Routes.map(s => ({AgreementRoutePriceId:s.AgreementRoutePriceId,NewPrice:s.NewPrice}))
            }
            AgreementApi.UpdatePrices(payload).then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('calculate-prices')
                    this.$emit('calculated',false)
                }
                this.updating = false
                this.currentUpdatingId = null
            }).catch(err => {
                this.$result(null,err)
                this.updating = false
                this.currentUpdatingId = null
            })
        }
    },
    computed:{
        date_format(){
            return moment(this.date,'YYYY-MM-DD').format('MM.DD.YYYY')
        }
    }
}
</script>